import useAxiosPrivate from "../hooks/useAxiosPrivate.js";
import React, { useState, useEffect, useCallback } from "react";
import SharedSettings from "../SharedSettings.js";

const LeagueSettings = (props) => {

    const axiosPrivate = useAxiosPrivate();

    const [isLoading, setIsLoading] = useState(false);
    const [leagueName,setLeagueName] = useState("");
    const [leagueCreator,setLeagueCreator] = useState("");
    const [leaguePrivate,setLeaguePrivate] = useState("No")

    const [leaguePass,setLeaguePass] = useState("");

    const [settingsData,setSettingsData] = useState({});

    const fetchData = useCallback( async() => {
        setIsLoading(true);
        const dataSend = {league_id:props.league_id};
        console.log(dataSend);
        try {
            const response = await axiosPrivate.post('/league/getSettings',dataSend)

            const settings = response.data[0];

            let maxSharesPerTeam = "No";
            let playoffMultipliers = "No";
            let leagueShorting = "Blocked";
            const roster_data = new Map();
            let transCostString = '';
            let budget = 0;

            console.log("get league settings data response");
            console.log(response.data); //debugger
            if (response?.data?.length>1){
                //got two sets of results for one league settings request, this shouldnt happen!
                console.log("Error in gettting league settings");
            }
            //setIsLoading(false);
            setLeagueName(settings.league_name);

            setLeagueCreator(settings.username);
            const timeframe = ((settings.timeframe<0) ? String(settings.timeframe*-1) : (settings.timeframe_name));

            if (settings.private){
                setLeaguePrivate("Private");
                setLeaguePass(settings.lg_pass);
            }
            else {
                setLeaguePrivate("Public")
            }

            const leagueSportId = (settings.sport_league_id);

            const leagueInseason = (settings.inseason ? "Yes" :"No");


            const lg_format = settings.lg_format;

            if (lg_format===0){
                budget = (settings.budget)
                leagueShorting = (settings.shorting ? "Allowed" : "Blocked")
                //setLeagueTransType(settings.trans_cost_type);
                //setLeagueTransAmnt(settings.transaction_cost);
                //setLeagueTransPercent(settings.transaction_cost_percent);
                //setLeagueTransPershare(settings.transaction_cost_pershare);

                let first = false;
                if (settings.trans_cost_type===1){
                    transCostString += "Global: "
                }
                if (Number(settings.transaction_cost)>0.0){
                    if (first){
                        transCostString += " + "
                    }
                    else {
                        first = true;
                    }
                    transCostString += ("$" + Number(settings.transaction_cost).toFixed(2))
                }
                if (Number(settings.transaction_cost_percent)>0.0){
                    if (first){
                        transCostString += " + "
                    }
                    else {
                        first = true;
                    }
                    transCostString += (Number(settings.transaction_cost_percent).toFixed(2) + "%")
                }
                if (Number(settings.transaction_cost_pershare)>0.0){
                    if (first){
                        transCostString += " + "
                    }
                    else {
                        first = true;
                    }
                    transCostString += (Number(settings.transaction_cost_pershare).toFixed(2) + " per Share.")
                }
                if (!first){
                    transCostString = "Free";
                }

            }
            else if (lg_format===1) {

                if (settings.maxsharesperteam){
                    const maxteamshares = settings.maxsharesperteam;
                    if (maxteamshares===1){
                        maxSharesPerTeam = "Yes"
                    }
                    else if (maxteamshares>1){
                        maxSharesPerTeam = (String(maxteamshares))
                    }
                }

                playoffMultipliers = (settings.playoff_multipliers ?  "Yes" : "No");

                const response2 = await axiosPrivate.post('/league/getRosterSettings',dataSend);

                console.log(response2.data)
                const roster_data = new Map();

                for (const pos of response2.data){
                    roster_data.set(pos.position_id,pos.quantity);
                }

                console.log(roster_data)
            }

            const sData = {
                sportId: leagueSportId,
                timeframe: timeframe,
                format: lg_format,
                budget: budget,
                transactionType: transCostString ,
                shorting: leagueShorting,
                inseason: leagueInseason,
                multiplers: playoffMultipliers,
                maxSharesPerTeam: maxSharesPerTeam,
                rosterData: roster_data


            }
            setSettingsData(sData);



        }
        catch (err){

        }

        setIsLoading(false);
      }, [axiosPrivate,props.league_id])
    
      useEffect( () => {
        fetchData();
      }, [fetchData]);

      return (
        <span>


            {!isLoading &&
                <div>
                    <br></br>League Name: {leagueName}
                    <br></br> League Creator: {leagueCreator}
                    <br></br> Privacy: {leaguePrivate}
                    {leaguePrivate==="Private" && <span>
                    <br></br> Password: {leaguePass}</span>}

                    <SharedSettings settingsData={settingsData} />


                </div>
            }
        </span>
      )

}


export default LeagueSettings;